import type { CSSProperties } from 'react';

interface Props {
  value: number; // 0-100
  color?: string;
  style?: CSSProperties;
}

export default function Progress({ value, color, style }: Props) {
  const pct = Math.max(0, Math.min(100, value));
  return (
    <div className="score-bar" style={style}>
      <div style={{ width: `${pct}%`, background: color }} />
    </div>
  );
}
